import { apiConverter } from '@front/repository/Api/converter';
import { getApiClient } from '@front/repository/common/apiClient';
import type { ISourceSystemRepository as I } from './interface';

export class SourceSystemRepository implements I {
  list: I.List = async ({ projectId }, options) => {
    const res = await getApiClient().POST('/source-system/list', {
      body: { projectId },
      signal: options?.signal,
    });
    if (!res.data) throw new Error('Failed to list source systems');
    return res.data.map(apiConverter.SourceSystem.fromApi);
  };

  get: I.Get = async ({ projectId, id }, options) => {
    const res = await getApiClient().POST('/source-system/get', {
      body: { projectId, id },
      signal: options?.signal,
    });
    if (!res.response.ok) throw new Error('Failed to get source system');
    return res.data ? apiConverter.SourceSystem.fromApi(res.data) : undefined;
  };

  create: I.Create = async ({ projectId, createProps }, options) => {
    const res = await getApiClient().POST('/source-system/create', {
      body: {
        projectId,
        displayName: createProps.displayName,
        description: createProps.description,
        isActive: createProps.isActive,
      },
      signal: options?.signal,
    });
    if (!res.data) throw new Error('Failed to create source system');
    return apiConverter.SourceSystem.fromApi(res.data);
  };

  update: I.Update = async ({ projectId, id, updateProps }, options) => {
    const res = await getApiClient().POST('/source-system/update', {
      body: {
        projectId,
        id,
        displayName: updateProps.displayName,
        description: updateProps.description,
      },
      signal: options?.signal,
    });
    if (!res.data) throw new Error('Failed to update source system');
    return apiConverter.SourceSystem.fromApi(res.data);
  };

  remove: I.Remove = async ({ projectId, id }, options) => {
    const res = await getApiClient().POST('/source-system/delete', {
      body: { projectId, id },
      signal: options?.signal,
    });
    if (!res.response.ok) throw new Error('Failed to delete source system');
  };
}
